const NextAvailableTrips = {
  getNextAvailableTrips: `ExternalSale/getNextAvailableTrips`,
};

export default NextAvailableTrips;
